import React, { useState } from 'react';

const FaqComponent = ({ 
  title = "Frequently Asked Questions",
  description,
  viewAllLink = "",
  questions = [],
  className = "",
  gradientBg = "bg-gradient-to-r from-orange-400 via-purple-600 to-purple-900"
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={`py-16 sm:py-24 ${gradientBg} ${className}`}>
      <div className="px-6 mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-2">
          {/* Left Column - Title Section */}
          <div className="max-w-xl">
            <h2 className="text-3xl font-normal text-white sm:text-4xl lg:text-5xl">
              {title}
            </h2>
            {description && (
              <p className="mt-6 text-base text-gray-200 sm:text-lg">
                {description}
              </p>
            )}
            {viewAllLink && (
              <a
                href={viewAllLink}
                className="inline-block px-4 py-2 mt-6 text-sm font-medium text-white border border-white rounded-md hover:bg-white/10 transition-colors"
              >
                View All FAQ
              </a>
            )}
          </div>

          {/* Right Column - FAQ Items */}
          <div className="space-y-4">
            {questions.map((faq, index) => (
              <div
                key={index}
                className="overflow-hidden bg-white rounded-lg"
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className="flex items-center justify-between w-full px-6 py-4 text-left"
                >
                  <span className="text-base font-medium text-gray-900 sm:text-lg">
                    {faq.question}
                  </span>
                  <span className="flex items-center justify-center w-8 h-8 ml-4">
                    <svg
                      className={`w-6 h-6 transition-transform duration-200 ${
                        openIndex === index ? 'rotate-45' : ''
                      }`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                  </span>
                </button>
                <div
                  className={`transition-all duration-300 ease-in-out ${
                    openIndex === index
                      ? 'max-h-96 opacity-100'
                      : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-6 pb-4 text-base text-gray-600">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqComponent;
